import React from "react";

import MDInput from "materialDashboard/components/MDInput";
import MenuItem from "@mui/material/MenuItem";
import {useTranslation} from "react-i18next";


const labelFnWithoutCode = (r) => r.description;
const labelFnWithCode = (r) => `${r.code} - ${r.description}`


const SelectFromRegistry = ({value, registry, onChange, labelFn,  labelWithCode = false, attrValue = 'code', addEmptyItem=true, ...props }) => {
    const {t} = useTranslation("inputs");
    const renderLabel = labelFn ?? (labelWithCode ? labelFnWithCode : labelFnWithoutCode);

    return <MDInput select
                    value={value ?? ''}
                    onChange={onChange}
                    variant="standard"
                    fullWidth
                    SelectProps={{
                        displayEmpty: true,
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    {...props}>
        {
            addEmptyItem && <MenuItem label="" value="">{t('selectFromRegistry.labelAny')}</MenuItem>
        }
        {
            registry.map((r) => <MenuItem key={r[attrValue]} value={r[attrValue]}>{renderLabel(r)}</MenuItem>)
        }
    </MDInput>
}

export default SelectFromRegistry;